import React from 'react';
import { Badge } from '../../components/ui/badge';
import { cn } from '../../lib/utils';

export type StatusType = 
  | 'active' 
  | 'pending' 
  | 'completed' 
  | 'in-progress' 
  | 'approved' 
  | 'draft'
  | 'approval_pending'
  | 'rejected'
  | 'inactive';

interface StatusBadgeProps {
  status: StatusType | string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  let variant: 
    | 'default'
    | 'secondary'
    | 'destructive'
    | 'outline'
    | 'success'
    | 'warning'
    | 'info';
    
  let label: string;
  
  switch (status) {
    case 'active':
      variant = 'success';
      label = 'Active';
      break;
    case 'completed':
      variant = 'success';
      label = 'Completed';
      break;
    case 'approved':
      variant = 'success';
      label = 'Approved';
      break;
    case 'pending':
      variant = 'warning';
      label = 'Pending';
      break;
    case 'in-progress':
      variant = 'info';
      label = 'In Progress';
      break;
    case 'approval_pending':
      variant = 'warning';
      label = 'Awaiting Approval';
      break;
    case 'draft':
      variant = 'secondary';
      label = 'Draft';
      break;
    case 'rejected':
      variant = 'destructive';
      label = 'Rejected';
      break;
    case 'inactive':
      variant = 'destructive';
      label = 'Inactive';
      break;
    default:
      variant = 'secondary';
      label = status?.charAt(0).toUpperCase() + status?.slice(1).replace(/_/g, ' ');
  }
  
  return (
    <Badge variant={variant} className={cn(className)}>
      {label}
    </Badge>
  );
};

export default StatusBadge;